export default function avatarAddress(id: number | undefined) {
  return `/avatar/my_image${String(
    id ? ((id % 15) + 1 === 4 ? 2 : (id % 15) + 1) : 4
  ).padStart(2, "0")}.jpg`;
}
